import {InputLabel, FormGroup, Paper, TextField, Typography, FormControl, Button, MenuItem, Select, FormControlLabel, Checkbox} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import GetRole from "./user";
import { useAppData } from "./appDataContext.js";
//import {createHotel, getHotels} from "../actions/customer"
import { fetchEmployeebyId, updateEmployeedata, fetchEmployees, fetchAsset} from "../api/customerapi";
import { v4 as uuidv4 } from "uuid";



const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(40),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    textField2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(20),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Employeedataupdate = () => {

    const classes = useStyles();
    const currenturl=window.location.href;
    const urlarray=currenturl.split("/");
    const currentid=urlarray[urlarray.length-1];
    var {cuser, role}=GetRole();
    //const dispatch=useDispatch();
    const [employeeData, setemployeeData] =useState({
        name: "",
        email:"",
        short_name:"",
        reporting_manager: "",
        designation:"",
        role:"",
        holiday_details:"",
    });
    const [perm, setperm]=useState({
      show_number:true,
      override:true,
      manual_cancellation:true,
    });
    const [eData, seteData]=useState([{}]);
    const [targetData, settargetData]=useState([]);
    const [holidayData, setholidayData]=useState([]);
     const [assetlist, setassetlist]=useState([]);
    const getEmployeebyId = async (currentid) => {
        try{
        const data = await fetchEmployeebyId(currentid);
        if(data.data.permissions){
          setperm(data.data.permissions)
        }
        //const custdatalistfromdb= data.data
        setemployeeData(data.data)
        settargetData(data.data.targets)
        setholidayData(data.data.leave_record)
         const data2= await fetchAsset();
                    console.log(data2.data)
                    var temp=data2.data[0].assetlist.filter(a=>a.owner==data.data.short_name)
                    console.log(temp)
                    if(temp.length>0){
                      setassetlist(temp)
                    }
    }catch(err){
        console.log(err)
      }
    }

    const getEmployees = async () => {
        try{
        const data = await fetchEmployees();
        //const custdatalistfromdb= data.data
        seteData(data.data.filter(emp => emp.role=="Admin" || emp.role=="TL" || emp.role=="SME" || emp.role=="HR" || emp.role=="Support" || emp.role=="Operations" || emp.role=="Operations-TL" || emp.role=="Manager" || emp.role=="Product" || emp.role=="Marketing" || emp.role=="Accounts"))
    }catch(err){
        console.log(err)
      }
    }

    const monthchange = (e, tid, id) => {
        const newdata = targetData[tid];
        //console.log(newdata)
        const newitem = { ...newdata, month: e.target.value };
        //console.log(newitem)
        settargetData(targetData.map((item) => (item.id == id ? newitem : item)));
        //setdata([...data, data[tid]=newitem])
        // console.log(cpdata)
      };
    
      const amountchange = (e, tid, id) => {
        const newdata = targetData[tid];
        //console.log(id, tid)
        const newitem = { ...newdata, value: e.target.value };
        //console.log(newitem)
        //cpdata[tid]=newitem
        // const newcpdata=cpdata.filter(item => item.id !=id)
        // setcpdata([...newcpdata, newitem])
        settargetData(targetData.map((item) => (item.id == id ? newitem : item)));
        //console.log(cpdata[tid])
      };

      const convchange = (e, tid, id) => {
        const newdata = targetData[tid];
        //console.log(id, tid)
        const newitem = { ...newdata, conv: e.target.value };
        //console.log(newitem)
        //cpdata[tid]=newitem
        // const newcpdata=cpdata.filter(item => item.id !=id)
        // setcpdata([...newcpdata, newitem])
        settargetData(targetData.map((item) => (item.id == id ? newitem : item)));
        //console.log(cpdata[tid])
      };

      const categorychange = (e, tid, id) => {
        const newdata = targetData[tid];
        //console.log(id, tid)
        const newitem = { ...newdata, sales_category: e.target.value };
        //console.log(newitem)
        //cpdata[tid]=newitem
        // const newcpdata=cpdata.filter(item => item.id !=id)
        // setcpdata([...newcpdata, newitem])
        settargetData(targetData.map((item) => (item.id == id ? newitem : item)));
        //console.log(cpdata[tid])
      };

     

   

    useEffect(() => {
        getEmployees()
        getEmployeebyId(currentid)
        //getAsset()
        
    }, [])

    const addcp = () => {
        //console.log(count)
    
        settargetData(
            targetData.length == 0 ? [{ id: uuidv4() }] : [...targetData, { id: uuidv4() }]
        );
      };
    
      const removecp = () => {
        settargetData([...targetData].slice(0, targetData.length - 1));
      };

      const addlr = () => {
        //console.log(count)
    
        setholidayData(
            holidayData.length == 0 ? [{ id: uuidv4() }] : [...holidayData, { id: uuidv4() }]
        );
      };
    
      const removelr = () => {
        setholidayData([...holidayData].slice(0, holidayData.length - 1));
      };

      const startchange = (e, tid, id) => {
        const newdata = holidayData[tid];
        //console.log(id)
        const newitem = { ...newdata, start_date: e.target.value };
        //console.log(newitem)
        //cpdata[tid]=newitem
        // const newcpdata=cpdata.filter(item => item.id !=id)
        // setcpdata([...newcpdata, newitem])
        setholidayData(holidayData.map((item) => (item.id == id ? newitem : item)));
        //console.log(cpdata[tid])
      };

      const endchange = (e, tid, id) => {
        const newdata = holidayData[tid];
        //console.log(id)
        const newitem = { ...newdata, end_date: e.target.value };
        //console.log(newitem)
        //cpdata[tid]=newitem
        // const newcpdata=cpdata.filter(item => item.id !=id)
        // setcpdata([...newcpdata, newitem])
        setholidayData(holidayData.map((item) => (item.id == id ? newitem : item)));
        //console.log(cpdata[tid])
      };

      const typechange = (e, tid, id) => {
        const newdata = holidayData[tid];
        //console.log(id)
        const newitem = { ...newdata, leave_type: e.target.value };
        //console.log(newitem)
        //cpdata[tid]=newitem
        // const newcpdata=cpdata.filter(item => item.id !=id)
        // setcpdata([...newcpdata, newitem])
        setholidayData(holidayData.map((item) => (item.id == id ? newitem : item)));
        //console.log(cpdata[tid])
      };

      const reasonchange = (e, tid, id) => {
        const newdata = holidayData[tid];
        //console.log(id)
        const newitem = { ...newdata, reason: e.target.value };
        //console.log(newitem)
        //cpdata[tid]=newitem
        // const newcpdata=cpdata.filter(item => item.id !=id)
        // setcpdata([...newcpdata, newitem])
        setholidayData(holidayData.map((item) => (item.id == id ? newitem : item)));
        //console.log(cpdata[tid])
      };
    //console.log(dest);

    const handleSubmit =async (e) => {
        try{
        e.preventDefault();
        const finalemployeeData={...employeeData, targets:targetData, leave_record: holidayData, permissions:perm}
        console.log(finalemployeeData)
        const updateemployeeResponse= await updateEmployeedata(employeeData._id, finalemployeeData);
        
        if(updateemployeeResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("Data updated for employee with employee id "+updateemployeeResponse.data.employee_id);
            window.location = ("/employeedataentry/"+updateemployeeResponse.data.employee_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }  
    }catch(err){
        console.log(err)
      }     
    }

    return ( 
        <Paper variant="outlined" className={classes.paper} elevation={10}>
            <Typography variant="h4" align="center" className={classes.headertext}> Update Employee</Typography>
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  required label="Name"  value={employeeData.name} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, name: e.target.value})}/>
                <TextField variant="standard"  label="Email"  value={employeeData.email} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, email: e.target.value})}/>
                <TextField variant="standard"  label="Contact"  InputLabelProps={{ shrink: true }} value={employeeData.contact} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, contact: e.target.value})}/>
                <TextField variant="standard"  label="Cloud (number)"  InputLabelProps={{ shrink: true }} value={employeeData.cloud_number} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, cloud_number: e.target.value})}/>
                
            </FormGroup>
           

            <FormGroup row className={classes.formgroup}>
            <TextField variant="standard"  required label="Short Name"  value={employeeData.short_name} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, short_name: e.target.value})}/>
            <TextField variant="standard"  required label="Proxy Name"  InputLabelProps={{ shrink: true }} value={employeeData.proxy_name} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, proxy_name: e.target.value})}/>
            
            <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="Designation">Designation</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Designation" value={employeeData.designation} onChange={(e)=> setemployeeData({...employeeData, designation: e.target.value})}>
                    <MenuItem value={"L1-Sales"}>L1-Sales</MenuItem>
                    <MenuItem value={"L2-Sales"}>L2-Sales</MenuItem>
                    <MenuItem value={"L3-Sales"}>L3-Sales</MenuItem>
                    <MenuItem value={"L4-Sales"}>L4-Sales</MenuItem>
                    <MenuItem value={"L1-Operations"}>L1-Operations</MenuItem>
                    <MenuItem value={"L2-Operations"}>L2-Operations</MenuItem>
                    <MenuItem value={"L3-Operations"}>L3-Operations</MenuItem>
                    <MenuItem value={"L4-Operations"}>L4-Operations</MenuItem>
                    <MenuItem value={"L1-Marketing"}>L1-Marketing</MenuItem>
                    <MenuItem value={"L2-Marketing"}>L2-Marketing</MenuItem>
                    <MenuItem value={"L3-Marketing"}>L3-Marketing</MenuItem>
                    <MenuItem value={"L4-Marketing"}>L4-Marketing</MenuItem>
                    <MenuItem value={"L1-Accounts"}>L1-Accounts</MenuItem>
                    <MenuItem value={"L2-Accounts"}>L2-Accounts</MenuItem>
                    <MenuItem value={"L3-Accounts"}>L3-Accounts</MenuItem>
                    <MenuItem value={"L4-Accounts"}>L4-Accounts</MenuItem>
                    <MenuItem value={"L1-Product"}>L1-Product</MenuItem>
                    <MenuItem value={"L2-Product"}>L2-Product</MenuItem>
                    <MenuItem value={"L3-Product"}>L3-Product</MenuItem>
                    <MenuItem value={"L4-Product"}>L4-Product</MenuItem>
                    <MenuItem value={"L1-HR & Admin"}>L1-HR & Admin</MenuItem>
                    <MenuItem value={"L2-HR & Admin"}>L2-HR & Admin</MenuItem>
                    <MenuItem value={"L3-HR & Admin"}>L3-HR & Admin</MenuItem>
                    <MenuItem value={"L4-HR & Admin"}>L4-HR & Admin</MenuItem>

                    <MenuItem value={"L5"}>L5</MenuItem>
                    <MenuItem value={"L6"}>L6</MenuItem>
                    <MenuItem value={"L7"}>L7</MenuItem>
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="Manager">Reporting Manager</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Manager" value={employeeData.reporting_manager} onChange={(e)=> setemployeeData({...employeeData, reporting_manager: e.target.value})}>
                    
                    {eData.map(emp => {
                    return <MenuItem value={emp.short_name}>{emp.name}</MenuItem>})}
                    
                </Select>
                </FormControl>
                {cuser=="Debayan"?(
                  <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="Role">Role</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Role" disabled={(cuser=="Debayan" || cuser=="Amit" || cuser=="Abhishek" || cuser=="Pawan")?0:1} value={employeeData.role} onChange={(e)=> setemployeeData({...employeeData, role: e.target.value})}>
                    <MenuItem value={"Admin"}>Admin</MenuItem>
                    <MenuItem value={"Manager"}>Manager</MenuItem>
                    <MenuItem value={"TL"}>TL</MenuItem>
                    <MenuItem value={"Sales"}>Sales</MenuItem>
                    <MenuItem value={"SME"}>SME</MenuItem>
                    <MenuItem value={"Operations"}>Operations</MenuItem>
                    <MenuItem value={"Operations-TL"}>Operations-TL</MenuItem>
                    <MenuItem value={"Product"}>Product</MenuItem>
                    <MenuItem value={"Support"}>Support</MenuItem>
                    <MenuItem value={"Sales Support"}>Sales Support</MenuItem>
                    <MenuItem value={"Accounts"}>Accounts</MenuItem>
                    <MenuItem value={"HR"}>HR</MenuItem>
                    <MenuItem value={"Ex-employee"}>Ex-employee</MenuItem>
                    <MenuItem value={"External"}>External</MenuItem>
                    <MenuItem value={"Marketing"}>Marketing</MenuItem>
                </Select>
                </FormControl>
                ):(
                  <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="Role">Role</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Role" disabled={(cuser=="Debayan" || cuser=="Amit" || cuser=="Abhishek" || cuser=="Pawan")?0:1} value={employeeData.role} onChange={(e)=> setemployeeData({...employeeData, role: e.target.value})}>
                  
                    
                    <MenuItem value={"TL"}>TL</MenuItem>
                    <MenuItem value={"Sales"}>Sales</MenuItem>
                    <MenuItem value={"SME"}>SME</MenuItem>
                    <MenuItem value={"Operations"}>Operations</MenuItem>
                    <MenuItem value={"Operations-TL"}>Operations-TL</MenuItem>
                    <MenuItem value={"Product"}>Product</MenuItem>
                    <MenuItem value={"Support"}>Support</MenuItem>
                    <MenuItem value={"Sales Support"}>Sales Support</MenuItem>
                    <MenuItem value={"HR"}>HR</MenuItem>
                    <MenuItem value={"Ex-employee"}>Ex-employee</MenuItem>
                    <MenuItem value={"External"}>External</MenuItem>
                    <MenuItem value={"Marketing"}>Marketing</MenuItem>
                </Select>
                </FormControl>
                )}
                <TextField variant="standard"  label="Biometric Id"  InputLabelProps={{ shrink: true }} value={employeeData.biometric_id} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, biometric_id: e.target.value})}/>
                
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  type="date" label="Date of birth"  InputLabelProps={{ shrink: true }} value={"dob" in employeeData && employeeData.dob? employeeData.dob.split("T").slice(0,1):""} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, dob: e.target.value})}/>
                <TextField variant="standard"  type="date" label="Date of joining"  InputLabelProps={{ shrink: true }} value={"doj" in employeeData && employeeData.doj ?  employeeData.doj.split("T").slice(0,1):""} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, doj: e.target.value})}/>
                <TextField variant="standard"  type="date" label="Date of separation"  InputLabelProps={{ shrink: true }} value={"dos" in employeeData && employeeData.dos ? employeeData.dos.split("T").slice(0,1):""} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, dos: e.target.value})}/>
            </FormGroup>
            {cuser=="Debayan"?(<div>
              <FormGroup row className={classes.formgroup}>
              <FormControlLabel control={<Checkbox color="primary"/>}  value={perm.show_number} checked={perm.show_number} label="Show Number?" onChange={(e)=> setperm({...perm, show_number:!perm.show_number})}/>
              <FormControlLabel control={<Checkbox color="primary"/>}  value={perm.override} checked={perm.override} label="Override?" onChange={(e)=> setperm({...perm, override:!perm.override})}/>
              <FormControlLabel control={<Checkbox color="primary"/>}  value={perm.manual_cancellation} checked={perm.manual_cancellation} label="Manual Cancellation?" onChange={(e)=> setperm({...perm, manual_cancellation:!perm.manual_cancellation})}/>
              <FormControlLabel control={<Checkbox color="primary"/>}  value={perm.sample} checked={perm.sample} label="Check Sample Quote?" onChange={(e)=> setperm({...perm, sample:!perm.sample})}/>
              <FormControlLabel control={<Checkbox color="primary"/>}  value={perm.cnpcheck} checked={perm.cnpcheck} label="Skip CNP Check?" onChange={(e)=> setperm({...perm, cnpcheck:!perm.cnpcheck})}/>
             <FormControlLabel control={<Checkbox color="primary"/>}  value={perm.cnpcheck} checked={perm.cnpcheck} label="Call Record Must?" onChange={(e)=> setperm({...perm, callmust:!perm.callmust})}/>
              </FormGroup>
            </div>):("")}
             {assetlist && assetlist.length>0?(
               <div align="center">
              <Typography variant="h6" align="center" className={classes.headertext}>Assets</Typography>
              
              <FormGroup row className={classes.formgroup}>
             
              <br></br>
                {assetlist.map(a=><div>
                  <TextField variant="standard"  label="Asset Type"  InputLabelProps={{ shrink: true }} value={a.asset_type} className={classes.textField} disabled/>
                  <TextField variant="standard"  label="Identifier"  InputLabelProps={{ shrink: true }} value={a.identifier} className={classes.textField} disabled/>
                </div>)}
              </FormGroup>
              </div>
            ):("")}
            {targetData && targetData.map((item) => {
            return (
              <div id="payment">
                <FormGroup row className={classes.formgroup}>
                  <TextField
                    variant="standard"
                    label="Month"
                    name={targetData.indexOf(item)}
                    value={
                      item.month
                    }
                    className={classes.textField}
                    onChange={(e) => monthchange(e, e.target.name, item.id)}
                  />
                  <TextField
                    variant="standard"
                    label="Target Value"
                    InputLabelProps={{ shrink: true }}
                    name={targetData.indexOf(item)}
                    value={item.value}
                    className={classes.textField2}
                    onChange={(e) => amountchange(e, e.target.name, item.id)}
                  />
                  <TextField
                    variant="standard"
                    label="Conv Target"
                    InputLabelProps={{ shrink: true }}
                    name={targetData.indexOf(item)}
                    value={item.conv}
                    className={classes.textField2}
                    onChange={(e) => convchange(e, e.target.name, item.id)}
                  />
                  <TextField variant="standard"  label="Category"  name={targetData.indexOf(item)} InputLabelProps={{ shrink: true }} value={item.sales_category} className={classes.textField2} onChange={(e) => categorychange(e, e.target.name, item.id)}/>
                  
                </FormGroup>
              </div>
            );
          })}

          <FormGroup row className={classes.formgroup}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={addcp}
            >
              {" "}
              + Tranche
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={removecp}
            >
              {" "}
              - Tranche
            </Button>
          </FormGroup>
          {role=="Admin" || role=="HR" || cuser=="Tarun"?(<div>
            <Typography variant="h6" align="center" className={classes.headertext}>Holiday Record</Typography>
          <FormGroup row className={classes.formgroup}>
          <TextField
                    variant="standard"
                    label="PL Pending"
                    helperText="Total PL for the year 2023 is 7"
                    value={employeeData.pl}
                    className={classes.textField}
                    onChange={(e) => setemployeeData({...employeeData, pl:e.target.value})}
                  />
                   <TextField
                    variant="standard"
                    label="SL Pending"
                    helperText="Total PL for the year 2023 is 7"
                    value={employeeData.sl}
                    className={classes.textField}
                    onChange={(e) => setemployeeData({...employeeData, sl:e.target.value})}
                  />
                   <TextField
                    variant="standard"
                    disabled
                    label="Total Pending"
                    helperText="Total paid leaves is 14 for the year"
                    value={eval(employeeData.sl)+eval(employeeData.pl)}
                    className={classes.textField}
                    //onChange={(e) => setemployeeData({...employeeData, pl:employeeData.target.value})}
                  />
                   <TextField
                    variant="standard"
                    label="Holiday Details"
                    fullWidth 
                    multiline
                    helperText="Enter details of holidays"
                    value={employeeData.holiday_details}
                    className={classes.textArea}
                    onChange={(e) => setemployeeData({...employeeData, holiday_details:e.target.value})}
                  />
          </FormGroup>
          {holidayData && holidayData.map((item) => {
            return (
              <div id="payment">
                <FormGroup row className={classes.formgroup}>
                  <TextField
                    variant="standard"
                    label="Start Date"
                    type="date"
                    //inputProps={{ min: "2023-09-01", max:"2023-12-31" }}
                    InputLabelProps={{ shrink: true }}
                    id={holidayData.indexOf(item)}
                    value={item.start_date === undefined
                        ? ""
                        : item.start_date.split("T").slice(0, 1)}
                    className={classes.textField}
                    onChange={(e) => startchange(e, e.target.id, item.id)}
                  />
                  <TextField
                    variant="standard"
                    label="End Date"
                    type="date"
                    //inputProps={{ min: "2023-09-01", max:"2023-12-31" }}
                    InputLabelProps={{ shrink: true }}
                    id={holidayData.indexOf(item)}
                    value={item.end_date === undefined
                        ? ""
                        : item.end_date.split("T").slice(0, 1)}
                    className={classes.textField}
                    onChange={(e) => endchange(e, e.target.id, item.id)}
                  />
                  <FormControl style={{minWidth: 320, marginTop: 16, marginRight: 16, marginLeft: 8}}>
                  <InputLabel id="leave">Leave Type</InputLabel>
                  <Select displayEmpty className={classes.textField} labelId="leave"  InputLabelProps={{ shrink: true }} id={holidayData.indexOf(item)} value={item.leave_type} onChange={(e) => typechange(e, e.target.id, item.id)}>
                    <MenuItem value={"PL"}>PL</MenuItem>
                    <MenuItem value={"SL"}>SL</MenuItem>
                    <MenuItem value={"Adjusted"}>Adjsuted</MenuItem>
                    <MenuItem value={"Marriage Leave"}>Marriage Leave</MenuItem>
                    <MenuItem value={"Bereavement Leave"}>Bereavement Leave</MenuItem>
                    <MenuItem value={"LWP"}>LWP</MenuItem>
                    
                </Select>
                </FormControl>
                <TextField
                    variant="standard"
                    label="Reason"
                    id={holidayData.indexOf(item)}
                    value={item.reason}
                    className={classes.textField}
                    onChange={(e) => reasonchange(e, e.target.id, item.id)}
                  />
                  
                </FormGroup>
              </div>
            );
          })}
          <FormGroup row className={classes.formgroup}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={addlr}
            >
              {" "}
              + Tranche
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={removelr}
            >
              {" "}
              - Tranche
            </Button>
          </FormGroup>
          </div>):("")}
          
           
            <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href="/home" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
            </FormGroup>
              
            </form>
        </Paper>
     );
}

export default Employeedataupdate;